export interface Daterange {
  start: string;
  end: string;
}

export const DATE_FORMAT_STRING = 'YYYY-MM-DDTHH:mm:ss';
